module.exports = __webpack_public_path__ + "media/images/home/testimonials/jo-e189556c2b957cf76eb6bc98b71d1604.jpg";